/**
 * W1 — Solicitações internas aguardando autorização, nos tipos que a pessoa
 * autoriza (o backend já filtra). Mesmo número do sino.
 */
import React from "react";
import { Link } from "react-router-dom";

import { CardBody, CardFooter, KpiSub, KpiValor, LinkLight } from "../styles";
import { pendenciasSolicitacoes, temAcaoEmAlgumTipo } from "./_solicitacoesInternas";

export const meta = {
  id: "solicitacoes_aguardando",
  label: "Solicitações aguardando autorização",
  descricao: "Assistências e requisições internas que esperam sua autorização.",
  categoria: "Pendencias",
  permissoes: [],
  visivelPara: (hasAllPermissions, isMaster) => isMaster || temAcaoEmAlgumTipo(hasAllPermissions, "autorizar"),
  tamanho_default: "S",
  essencial: false,
};

export async function fetchData(request) {
  const r = await pendenciasSolicitacoes(request);
  return { aguardando: r?.aguardando_autorizacao ?? 0 };
}

export function Widget({ dados }) {
  const n = dados?.aguardando ?? 0;
  return (
    <>
      <CardBody>
        <KpiValor style={{ color: n > 0 ? "var(--warning-text)" : undefined }}>{n}</KpiValor>
        <KpiSub>{n > 0 ? "esperando autorização ou recusa" : "Nada esperando você"}</KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/suprimentos/gestao-solicitacoes">Abrir a Gestão</LinkLight>
      </CardFooter>
    </>
  );
}
